<template>
  <div>
    <navlist :navlist="about" />
    <router-view />
    
  </div>
</template>

<script>
import navlist from "../components/nav";
export default {
  components: {
    navlist
  },
  data() {
    return {
      about: [
        {
          path: "/about/introduction",
          name: "社区图"
        },
        // {
        //   path: "/about/honour",
        //   name: "社区荣誉"
        // },
        {
          path: "/about/leader",
          name: "领导关怀"
        },
        {
          path: "/about/media",
          name: "媒体报道"
        }
      ],
      local:'社区图' //当前位置
    };
  }
};
</script>

<style>
</style>